import { useEffect, useState } from "react";

export default function CoverImage({ city, className }) {
  const [image, setImage] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!city) return;

    const fetchImage = async () => {
      try {
        const res = await fetch(
          `https://api.unsplash.com/search/photos?query=${city}&per_page=1&orientation=landscape`,
          {
            headers: {
              Authorization: `Client-ID ${process.env.REACT_APP_UNSPLASH_KEY}`,
            },
          }
        );

        const data = await res.json();

        if (data.results?.length > 0) {
          setImage(data.results[0].urls.regular);
        }
      } catch (err) {
        console.error("Image fetch failed", err);
      } finally {
        setLoading(false);
      }
    };

    fetchImage();
  }, [city]);

  if (loading) {
    return (
      <div className={`bg-gray-200 animate-pulse ${className}`} />
    );
  }

  return (
    <img
      src={
        image ||
        "https://images.unsplash.com/photo-1507525428034-b723cf961d3e"
      }
      alt={city}
      className={`w-full h-full object-cover ${className}`}
      onError={(e) => {
        e.target.src =
          "https://images.unsplash.com/photo-1507525428034-b723cf961d3e";
      }}
    />
  );
}